export const BASE_URL = "https://api.ebullion.in"